<script setup lang="ts">
const selectedLeg = ref<'departure' | 'return'>('departure');
const searchCriteriaStore = useSearchCriteriaStore();

watch(
  () => searchCriteriaStore.isOneWay,
  (isOneWay) => {
    if (isOneWay) selectedLeg.value = 'departure';
  },
);
</script>

<template>
  <UiTabs v-model="selectedLeg">
    <UiTabsList v-if="!searchCriteriaStore.isOneWay">
      <UiTabsIndicator />
      <UiTabsTrigger value="departure">
        {{ $t('components.results.filters.legDeparture') }}
      </UiTabsTrigger>
      <UiTabsTrigger value="return">
        {{
          searchCriteriaStore.committedExtraLegs > 0
            ? $t('components.results.filters.legArrival')
            : $t('components.results.filters.legReturn')
        }}
      </UiTabsTrigger>
    </UiTabsList>
    <UiTabsContent value="departure">
      <slot name="departure" />
    </UiTabsContent>
    <UiTabsContent
      v-if="!searchCriteriaStore.isOneWay"
      value="return"
    >
      <slot name="return" />
    </UiTabsContent>
  </UiTabs>
</template>
